export function openDatabase() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('myDatabase', 1);

        request.onupgradeneeded = event => {
            const db = event.target.result;
            db.createObjectStore('files', { keyPath: 'id' });
        };

        request.onsuccess = event => {
            resolve(event.target.result);
        };

        request.onerror = event => {
            reject(event.target.error);
        };
    });
}

export function storeFile(id, file) {
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readwrite');
            const store = transaction.objectStore('files');
            const request = store.put({ id, file });

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
}

export function getFile(id) {
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readonly');
            const store = transaction.objectStore('files');
            const request = store.get(id);

            request.onsuccess = event => {
                resolve(event.target.result ? event.target.result.file : null);
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
}

export const getFileSign = (id) => {
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readonly');
            const store = transaction.objectStore('files');
            const request = store.get(id);

            request.onsuccess = event => {
                if (event.target.result) {
                    const base64File = event.target.result.file;
                    const binary = atob(base64File);
                    const array = [];
                    for (let i = 0; i < binary.length; i++) {
                        array.push(binary.charCodeAt(i));
                    }
                    const fileBlob = new Blob([new Uint8Array(array)], { type: 'application/pdf' });
                    resolve(fileBlob);
                } else {
                    reject('File not found');
                }
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
};

export function deleteFile(id) {
    return openDatabase().then(db => {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(['files'], 'readwrite');
            const store = transaction.objectStore('files');
            const request = store.delete(id);

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = event => {
                reject(event.target.error);
            };
        });
    });
}